<template>
  <button
    @click="handleClick"
    class="aha-storybook-dropdown-item"
    :class="{'active': isActive}"
    role="menuitem"
    ref="item"
    :title="title"
  >
    <aha-icon
      v-if="icon"
      :name="icon"
      :height="iconConfig.height"
      :width="iconConfig.width"
      :class="['mr-2', iconConfig.classes]"
      :viewBox="iconConfig.viewBox"
    />
    <slot />
  </button>
</template>

<script>
import AhaIcon from '../Icon.vue'

export default {
  name: 'DropdownItem',
  components: {
    AhaIcon,
  },
  inject: ['dropdownV2'],
  props: {
    color: {
      type: String,
      default: 'default',
    },
    className: {
      type: String,
      default: '',
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    iconConfig: {
      type: Object,
      default: () => ({
        height: 16,
        width: 16,
        classes: '',
        viewBox: '0 0 16 16',
      }),
    },
    icon: {
      type: String,
      default: '',
    },
  },
  computed: {
    isActive() {
      return this.dropdownV2.activeIndex === this.dropdownV2.items.indexOf(this)
    },
  },

  mounted() {
    document.addEventListener('click', this.closeDropdown)
    this.dropdownV2.registerItem(this)
  },
  destroyed() {
    this.dropdownV2.unregisterItem(this)
    document.removeEventListener('click', this.closeDropdown)
  },
  methods: {
    async handleClick() {
      await this.$emit('click')
      this.dropdownV2.closeDropdown()
    },
  },
}
</script>
<style lang="scss" scoped>
.aha-storybook-dropdown-item {
  @apply truncate;
  max-width: 300px;
  min-width: 150px;
  border: 1px solid transparent;
  width: 100%;
  padding: 8px 12px;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 4px;
}

.aha-storybook-dropdown-item:hover {
  background-color: #E6E6E6;
}

.aha-storybook-dropdown-item:focus {
  background-color: #CECECE;
  outline: none;
}

.active {
  border: 1px solid #89BEFA;
}

</style>
